import Nav from "@/components/landing/Nav";
import HeroSideStage from "@/components/landing/HeroSideStage";
import TheShift from "@/components/landing/TheShift";
import WhatWeDo from "@/components/landing/WhatWeDo";
import AllyAndVault from "@/components/landing/AllyAndVault";
import WhyNow from "@/components/landing/WhyNow";
import Privacy from "@/components/landing/Privacy";
import FAQ from "@/components/landing/FAQ";
import BookingCTA from "@/components/landing/BookingCTA";
import Footer from "@/components/landing/Footer";
import MobileStickyBar from "@/components/landing/MobileStickyBar";

export default function Landing() {
  return (
    <main className="relative">
      <Nav variant="v1" />
      <HeroSideStage />
      <TheShift />
      <WhatWeDo />
      <AllyAndVault />
      <WhyNow />
      <Privacy />
      <FAQ />
      <BookingCTA />
      <Footer />
      <MobileStickyBar />
    </main>
  );
}
